import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowModalToSignMassive = createSelector(
  [(store: RootState) => store.documentsSignerList.showModalToSignMassive],
  (data) => data
);
